module.exports = __webpack_public_path__ + "static/mobile-steak-4b4de514223b130971d66119da51b40e.png";